export const buildStaticResourceUtms = ({
  urlResource,
  resourceName,
  term,
}: {
  urlResource?: string;
  resourceName?: string;
  term?: string;
}) => {
  return {
    utm_source: 'organic-resources',
    utm_campaign: urlResource,
    utm_content: resourceName,
    utm_term: term,
  };
};
